export const SETTINGS = {
  DE_AUTO_TRADE_CREDIT_RECHECK_DELAY: 'de_auto_trade_credit_recheck_delay',
  DE_AUTO_TRADE_CREDIT_DISBURSEMENT_DELAY:
    'de_auto_trade_credit_disbursement_delay',
  DE_MIN_APPROVAL_AMOUNT: 'de_min_approval_amount',
} as const
